import {Feature, Features} from "../feature";

export const etherFilter = {
    filterInPlace: (features: Feature[]) => {
        const ethers = features.filter(f => f.name === Features.ether);
        const esters = features.filter(f => f.name === Features.ester || f.name === Features.anhydride);
        const partsOfEsters = ethers.filter(ether => esters.some(ester => ester.atoms.includes(ether.atoms[0])))
        partsOfEsters.forEach(ether => features.splice(features.indexOf(ether), 1));
    }
}